import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import SVG from 'components/SVG';

import formateNumber from 'shared/helpers/formateNumber';
import scrollToTop from 'shared/helpers/scrollToTop';

import { getImageName } from 'features/bonusProgram/data';
import editSVG from 'features/bonusProgram/data/img/edit.svg';
import deleteSVG from 'features/bonusProgram/data/img/delete.svg';
import './CurrentGiftsItem.scss';

const b = block('current-gifts-item-mobile');

const CurrentGiftsItem = ({ item, onDelete }) => {
  const locale = useSelector(s => s.locale.locale);

  return (
    <section className={b()}>
      <div className={b('value')}>{item.name}</div>

      <a className={b('value', { type: 'ellipsis' })} href={item.imageUrl} target='_blank' rel="noopener noreferrer">
        <div className={b('ellipsis')}>{getImageName(item.imageUrl)}</div>
      </a>

      <div className={b('value')}>{formateNumber(item.points, 2, 0)}</div>

      <div className={b('value', { status: item.active ? '1' : '0' })}>
        {item.active ? locale.active : locale.disable2}
      </div>

      <div className={b('value')}>
        <div className={b('icons')}>
          <Link
            className={b('icon-wrapper')}
            to={`/bonus-promo/management/${item.id}`}
            onClick={() => scrollToTop()}
          >
            <SVG className={b('icon')} svgProps={{ svg: editSVG }} />
            {locale.edit}
          </Link>

          <div className={b('icon-wrapper')} onClick={() => onDelete(item.id)}>
            <SVG className={b('icon')} svgProps={{ svg: deleteSVG }} />
            {locale.delete}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CurrentGiftsItem;
